// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__owH0A","select":"Header_select__zTHWY","clinic":"Header_clinic__2ESWu"};